import React from "react";
import "./index.scss";
import NumberBox from "devextreme-react/number-box";
import { IMdaeTextBoxProps as IMdaeNumericBoxProps } from "./index";
import { useDispatch } from "react-redux";
import {
  DX_WIDGET_NAMES,
  configureMdaeWidgetOptionUpdaters,
} from "../../mdae-framework";
import { RequiredFieldLabel } from "../required-field-label";

const MdaeNumericBox: React.FC<IMdaeNumericBoxProps> = (props) => {
  const dispatch = useDispatch();
  return (
    <div className={"sys-mdae-text-box-container"}>
      <NumberBox
        {...props}
        showSpinButtons={props.showSpinButtons === false ? false : true}
        onInitialized={(e) => {
          if (typeof props.onInitialized === "function") props.onInitialized(e);
          configureMdaeWidgetOptionUpdaters(
            props.mdaeDataUpdaterConfig,
            DX_WIDGET_NAMES.DX_NUMBER_BOX,
            e.component,
            dispatch
          );
        }}
      ></NumberBox>

      {props.visible !== false && (
        <span className={typeof props.MdaeNumberBoxTitleComponent === "function" ? "mdae-text-box-field-with-dollar-icon-set-text":"mdae-text-box-field-set-text"}>
          {props.mdaeNumberBoxTitle}
          {typeof props.MdaeNumberBoxTitleComponent === "function" && (
            <props.MdaeNumberBoxTitleComponent></props.MdaeNumberBoxTitleComponent>
          )}
          {props.required && <RequiredFieldLabel />}
        </span>
      )}
    </div>
  );
};
export default MdaeNumericBox;
